import React from 'react'
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D479 = () => {
    return (
        <div className="container" style={{ maxWidth: "80%" }}>
          <h1 className="text-center mt-4">
            WGU Course Buffet: All You Can Read 🍽️📖
          </h1>
          <Link type="button" class="btn btn-secondary" to="/courses">
            <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
          </Link>
    
          <h2 className="text-center">You're viewing D479 - User Experience Design</h2>
    
          <div className="card my-4">
            <h4 className="text-center mt-4">
            WGU Course Material : <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
              <i class="fa-solid fa-star"></i>
            </h4>
            <h4 className="text-center my-2">Total Time Taken: 1.78 hrs</h4>
            <hr />
            <div className="card-body">
              <p>
                Easiest course in this entire degree. You don’t even need the course
                material. I used Visual Studio Code and barely had to use the
                terminal. It has a nice interface and shows options to create
                branches, commit, push, and merge everything with an intuitive GUI.
                I just cloned my project by following the instructions in the PA and
                looked up commands online if I needed any.
              </p>
            </div>
          </div>
          <Footer/>
        </div>
      );
    };
export default D479
